import { useEffect, useRef, useState } from "react";
import { LOW_COINS, coinAria, coinCountText, coinRuns } from "./coins";

// The student's helper coins, shown by the Send button (coins.ts). A small coin drops when one is
// spent. The global reduced-motion rule in styles.css turns the drop off.

function Coin() {
  return (
    <svg className="coin-svg" viewBox="0 0 8 8" width={16} height={16} shapeRendering="crispEdges" aria-hidden="true">
      {coinRuns().map((r, i) => (
        <rect key={i} x={r.x} y={r.y} width={r.w} height={1} fill={r.c} />
      ))}
    </svg>
  );
}

export function CoinCounter({ left }: { left: number }) {
  // Counts spent coins so each one replays the drop; the first reading never animates.
  const [spent, setSpent] = useState(0);
  const last = useRef<number | null>(null);
  useEffect(() => {
    if (last.current !== null && left < last.current) setSpent((n) => n + 1);
    last.current = left;
  }, [left]);
  const label = coinAria(left);
  return (
    <span className={`coins${left <= LOW_COINS ? " low" : ""}`} role="img" aria-label={label} title={label}>
      <span className="coin-face">
        <Coin />
      </span>
      <span className="coin-text" aria-hidden="true">
        {coinCountText(left)}
      </span>
      {spent > 0 && (
        <span key={spent} className="coin-drop" aria-hidden="true">
          <Coin />
        </span>
      )}
    </span>
  );
}
